import React from "react";

interface AppTableHeaderCellProps
  extends React.ThHTMLAttributes<HTMLTableCellElement> {}

const AppTableHeaderCell: React.FC<AppTableHeaderCellProps> = ({ className = "", ...props }) => {
  return <th className={`px-4 py-2 ${className}`} {...props} />;
};

export default AppTableHeaderCell;